import React from "react";
import { useAuth } from "@/context/AuthContext";

/**
 * PawMark — paw print used next to the "TOTO" wordmark.
 * Color follows the current user's boutique. For Rainbow Interests leadership
 * (no boutique_code), a near-black paw is used.
 *
 * Shape follows the original TOTO mascot medallion: four oval toes arranged in an
 * arc (outer beans lower/tilted outward, inner beans higher) above a large,
 * horizontal oval pad.
 */
export default function PawMark({ size = 14, className = "", overrideBoutique = null, color: explicitColor = null }) {
  const { user } = useAuth();
  const boutique = overrideBoutique ?? user?.boutique_code ?? null;

  const color = explicitColor ?? (() => {
    switch (boutique) {
      case "PLT": return "#22C55E";
      case "FLL": return "#0EA5E9";
      case "WYN": return "#EC4899";
      case "PNC": return "#F97316";
      default:    return "#0F172A"; // Rainbow leadership → near-black
    }
  })();

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 48 48"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-label="Toto paw"
      role="img"
      data-testid="toto-paw"
    >
      {/* Four toe beans — outer pair tilted outward, inner pair upright */}
      <ellipse cx="10" cy="16" rx="4.4" ry="5.6" fill={color} transform="rotate(-18 10 16)" />
      <ellipse cx="19" cy="10" rx="4.2" ry="5.6" fill={color} />
      <ellipse cx="29" cy="10" rx="4.2" ry="5.6" fill={color} />
      <ellipse cx="38" cy="16" rx="4.4" ry="5.6" fill={color} transform="rotate(18 38 16)" />
      {/* Keep the simple oval pad used on the canonical mascot's gold medallion. */}
      <ellipse cx="24" cy="31" rx="12" ry="9" fill={color} />
    </svg>
  );
}
